<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="page.name"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row>
        <b-col
          md="6"
          sm="12"
        >

          <div
            v-if="isReferral"
            class="comment-number-container"
          >
            <label
              for="comment-num"
              class="flex-grow-1"
            >

              {{ $t('page.expire-date') }}  </label>
            <b-form-spinbutton
              id="comment-num"
              v-model.number="form.months"
              class="ml-sm-1 ml-md-3 flex-grow-0"
              style="max-width: 293px"
              min="1"
              max="3"
            />
          </div>
          <ok-date-time-picker
            v-else
            v-model="form[isInstagram?'expires_at':'expired_date']"
            :label="$t('page.expire-date')"
            is-required
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <general-templates-select
            v-model="form.package_id"
            is-required
            :label="$t('page.package')"
            :options="filteredPackages"
            @input="setCost"
          />
        </b-col>
        <b-col
          v-if="!isReferral"
          md="6"
          sm="12"
        >
          <general-templates-select
            v-model="form.referral_id"
            :label="$t('page.referral')"
            :options="referrals"
          />
        </b-col>
        <b-col
          v-if="!isInstagram && !isReferral"
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.domain"
            :label="$t('page.domain')"
            rules="url"
          />
        </b-col>
        <b-col md="6">
          <ok-text-input
            :value="totalCost"
            read-only
            :append="'ل.س'"
            is-append-text
            :label="$t('invoice.cost')"
          />
        </b-col>
        <b-col
          v-if="!isReferral"
          md="6"
        >
          <ok-text-input
            v-model="form.cost"
            :label="$t('invoice.cost')"
          />
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <b-col md="6">
          <div class="comment-number-container">
            <label
              for="comment-num"
              class="flex-grow-1"
            >

              {{ $t('reply.form.comment-number') }}  </label>
            <b-form-spinbutton
              id="comment-num"
              v-model="form.max_comments"
              class="ml-sm-1 ml-md-3 flex-grow-0"
              style="max-width: 293px"
              :min="1"
              :max="10"
            />
          </div>
        </b-col>
        <b-col
          v-if="!isReferral"
          md="6"
        >
          <div class="comment-number-container">
            <label
              for="ai-reply-limit-num"
              class="flex-grow-1"
            >
              AI Reply Limit
            </label>
            <b-form-spinbutton
              id="ai-reply-limit-num"
              v-model.number="form.ai_reply_limit"
              class="ml-sm-1 ml-md-3 flex-grow-0"
              style="max-width: 293px"
              :min="0"
              :max="1000000"
            />
          </div>
        </b-col>
        <b-col
          v-if="!isReferral"
          md="6"
        >
          <div class="comment-number-container">
            <label
              for="ai-limit-num"
              class="flex-grow-1"
            >
              Poster AI Limit
            </label>
            <b-form-spinbutton
              id="ai-limit-num"
              v-model.number="form.ai_limit"
              class="ml-sm-1 ml-md-3 flex-grow-0"
              style="max-width: 293px"
              :min="0"
              :max="1000000"
            />
          </div>
        </b-col>
        <b-col
          v-if="!isReferral"
          md="6"
        >
          <general-templates-select
            v-model="form.reset_period"
            :label="'Reset period'"
            :options="[
              { name: 'Daily', id: 'daily' },
              { name: 'Monthly', id: 'monthly' }
            ]"
            :clearable="false"
            label-key="name"
            value-key="id"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="!isReferral"
        class="align-items-center"
      >
        <b-col md="6">
          <div class="comment-number-container">
            <label
              for="ai-used-num"
              class="flex-grow-1"
            >
              AI Used
            </label>
            <b-form-spinbutton
              id="ai-used-num"
              v-model.number="form.ai_used"
              class="ml-sm-1 ml-md-3 flex-grow-0"
              style="max-width: 293px"
              :min="0"
              :max="1000000"
            />
          </div>
        </b-col>
      </b-row>
      <hr>
      <b-row
        v-if="!isReferral"
        class="d-flex align-items-center"
      >
        <b-col
          md="6"
          sm="12"
        >
          <b-form-checkbox
            v-model="form.ai_enabled"
            switch
          >
            Poster AI enabled
          </b-form-checkbox>
          <b-form-checkbox
            v-model="form.comment_algo_enable"
            switch
          >
            تفعيل خوارزمية التعليقات
          </b-form-checkbox>

          <b-form-checkbox
            v-model="form.invoice"
            switch
          >
            {{ $t('invoice.generate') }}
          </b-form-checkbox>
          <b-form-checkbox
            v-if="form.invoice"
            v-model="form.paid"
            switch
          >
            {{ $t('invoice.paid') }}
          </b-form-checkbox>
          <b-form-checkbox
            v-model="form.expired"
            switch
          >
            {{ $t('page.expired') }}
          </b-form-checkbox>
        </b-col>
        <template v-if="form.invoice">
          <b-col
            md="6"
            sm="12"
          >
            <ok-text-input
              v-model="form.invoicePeriod"
              :label="$t('invoice.period')"
            />
            <ok-text-input
              v-model="form.discount"
              :label="$t('invoice.discount')"
            />
          </b-col>
        </template>

      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.save') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BFormCheckbox, BFormSpinbutton,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkDateTimePicker from '@/@bya3/components/inputs/OkDateTimePicker'
import GeneralTemplatesSelect from '@/@bya3/components/inputs/GeneralTemplatesSelect'
import { mapGetters } from 'vuex'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import PageApi from '@/api/page'
import InstagramAccountsApi from '@/api/instagram/account'

export default {
  name: 'PageEditModal',
  components: {
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    GeneralTemplatesSelect,
    OkDateTimePicker,
    OkModal,
    BButton,
    BRow,
    BFormCheckbox,
    BCol,
    BFormSpinbutton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
    isInstagram: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,
      form: {},
      loading: false,
      commentsPrices: {
        1: 0, 2: 15000, 3: 20000, 4: 25000, 5: 30000, 6: 40000, 7: 50000, 8: 60000, 9: 70000, 10: 1000000,
      },
    }
  },
  computed: {
    ...mapGetters({
      packages: 'subscription/packages',
      referrals: 'auth/referrals',
      isReferral: 'auth/isReferral',
    }),
    filteredPackages() {
      return this.packages.filter(pack => pack.media_type === (this.isInstagram ? 'ig' : 'fb'))
    },
    totalCost() {
      const pkg = this.packages.find(pack => pack.id === this.form.package_id)

      return parseFloat((pkg?.original_price ?? 0)) + parseFloat((this.commentsPrices[this.form.max_comments] ?? 0))
    },
  },
  watch: {
    page() {
      this.error = null
      this.setForm()
    },
  },
  mounted() {
    this.setForm()
  },
  methods: {
    setCost(id) {
      const pkg = this.packages.find(pack => pack.id === id)
      this.form.cost = pkg.original_price
    },
    async setForm() {
      this.form = {
        expired_date: this.page.expired_date,
        expires_at: this.page.expires_at,
        expired: !!this.page.expired,
        package_id: this.page.package_id,
        domain: this.page?.domain ?? '',
        referral_id: this.page.referral_id,
        invoice: false,
        invoicePeriod: 1,
        paid: 0,
        discount: 0,
        max_comments: this.page?.max_comments ?? 1,
        cost: this.page?.cost ?? null,
        comment_algo_enable: !!(this.page?.comment_algo_enable ?? 0),
        ai_enabled: !!(this.page?.ai_enabled ?? 1),
        ai_limit: this.page?.ai_limit ?? 0,
        ai_reply_limit: this.page?.ai_reply_limit ?? 0,
        ai_used: this.page?.ai_used ?? 0,
        reset_period: this.page?.reset_period ?? 'monthly',
      }
      if (this.isReferral) {
        delete this.form.expired_date
        delete this.form.expires_at
        this.form.months = 1
      }
    },
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { ...this.form }
        if (this.isReferral) {
          form.cost = this.totalCost
        }
        await (this.isInstagram ? InstagramAccountsApi.updateAccount(this.page.id, form) : PageApi.updatePage(this.page.id, form)).then(res => {
          if (res.error === 0) {
            this.$notifySuccess(res.message)
            this.$emit('updated')
            this.$emit('input', false)
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
